// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"building-5"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M4 21V12.8889L12 8L20 12.8889V21H4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M6 11.6667V5.85699L11.9984 2L18 5.85729V11.6667L12 8L6 11.6667Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M12 17V21M19 6.5L11.9984 2L5 6.5M6 6.35V11.6667L12 7.99999L18 11.6667V6.3503","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M3 13.5L12 8L21 13.5M4 13.4V21H20V13.4","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-building-5')
export default class Building5Icon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'building-5',
    }
  }
}
